<template>
  <v-container style="margin: auto;">
    <div :class="navBarStyle">
      <Titulo></Titulo>
    </div>


    <div style="width: 94%; margin: auto;">

    <NavBar :step="0" />
    <br>
    
    <v-row  v-if="screen > 800" class="margin-top">
      <img :src="casita" alt="Image c" class="casita-img">
      <img :src="banner" alt="Image b" class="banner-img">
    </v-row>

    <v-col v-if="screen < 800" style="margin-top: -27%; margin-bottom: -8%;">
        <img :src="bannerMobile" alt="Image b" class="banner-img" style="margin: auto;">
        <img :src="casitaMobile" alt="Image c" class="casita-img" style="margin-top: -10%;margin-left: 5%;">
    </v-col>

    <br>
    <br>

    <v-stepper v-model="e1" elevation="0">

      <v-stepper-header >
        <div class="circle-step">
          <v-stepper-step style="flex-direction: column;" :class="stepperStyle" :color="stepperColor" :complete="e1 > 1" step="1"> Inicio
          </v-stepper-step>
        </div>
        <v-divider :class="dividerStyle"></v-divider>
        <div class="">
          <v-stepper-step style="flex-direction: column;" :class="stepperStyle" :color="stepperColor" :complete="e1 > 2" step="2"> Plan
          </v-stepper-step>
        </div>
        <v-divider :class="dividerStyle"></v-divider>
        <div :class="circleStep2Inicio">
          <v-stepper-step style="flex-direction: column;" :class="stepperStyle" :color="stepperColor" :complete="e1 > 3" step="3"> Beneficiarios
          </v-stepper-step>
        </div>
        <v-divider :class="dividerStyle"></v-divider>
        <div class="circle-step2-inicio-final">
          <v-stepper-step style="flex-direction: column;" :class="stepperStyle" :color="stepperColor" step="4"> Datos </v-stepper-step>
        </div>
      </v-stepper-header>

      <br v-if="screen > 800">
      <br v-if="screen > 800">

      <v-stepper-items>
        <v-stepper-content step="1">
          <div :class="formText">

            <v-form ref="form" v-model="valid" max-witdh="300px">

              <div v-if="screen < 800" style="margin-bottom: -3%;">
                <h3 class="text-center labelQuestion">¡Hola! ¿Cómo te llamas?</h3>
              </div>
              <div v-else>
                <h3 class="text-center labelHola">¡Hola!</h3>
                <h3 class="text-center labelQuestion">¿Cómo te llamas?</h3>
              </div>

              <br>
              <br>

              <div class="labels">
                <label>Nombre</label>
              </div>
              <v-text-field class="labelNombre" id="input-22" v-model="userData.name" :rules="nameRules" label="Nombre" required
                maxlength="51" filled solo @change="change()"></v-text-field>
        
              <br>
                
              <div class="labels">
                <label>Apellido</label>
              </div>
              <v-text-field class="labelNombre" id="input-25" v-model="userData.surname" @change="change()" :rules="surnameRules"
                maxlength="51" label="Apellido" required filled solo></v-text-field>
       


              <br>
              <br>

              <h3 class="text-center labelQuestion">¿Cuál es tu email?</h3>

              <h4 class="text-center labelSubQuestion">Aquí enviaremos tu póliza de seguro.</h4>

              <div class="labels">
                <label>Email</label>
              </div>
              <v-text-field class="labelEmail" id='input-28' v-model="userData.email" @change="change()" :rules="emailRules"
                maxlength="51" label="Escribe tu email" required filled solo></v-text-field>

              <br>
              <br>

              <h3 class="text-center labelQuestion">¿Cuál es tu edad?</h3>

              <h4 class="text-center labelSubQuestion">Es para recomendarte el mejor seguro.</h4>

              <v-row v-if="screen < 800" style="margin-top: 2%;margin-bottom: -16%;">
                
                <v-col>
                  <div class="labelsSelectMobile">
                    <label>Día</label>
                  </div>
                  <v-select class="labelDatesMovil" style="max-width: 90px; height: 48px;margin-left: 5%;" :rules="dayRules"
                    :items="days" v-model="userData.day" :loading="loadingDays"
                    :disabled="loadingDays || userData.month === null" item-text="name" label="Día" return-object
                    required filled solo>
                  </v-select>
                </v-col>

                <v-col>
                  <div class="labelsSelectMobile" >
                    <label>Mes</label>
                  </div>
                  <v-select class="labelDatesMovil" style="max-width: 90px; height: 48px;margin-left: 5%;" :rules="monthRules"
                    :items="months" v-model="userData.month" :loading="loadingMonths" v-on:change="getDays()"
                    item-text="name" label="Mes" return-object required filled solo></v-select>
                </v-col>

                <v-col>
                  <div class="labelsSelectMobile">
                    <label>Año</label>
                  </div>
                  <v-select class="labelDatesMovil" style="max-width: 90px; height: 48px;margin-left: 5%;" :rules="yearRules"
                    value="2022" :items="years" v-model="userData.year" item-text="name" label="Año" return-object
                    required filled solo></v-select>
                </v-col>

              </v-row>

              <v-row v-else>
                <v-col>
                  <div class="labelsFlex">
                    <label>Día</label>
                  </div>
                  <v-select class="labelDatesdesktop" style="max-width: 160px; height: 48px;" :rules="dayRules"
                    :items="days" v-model="userData.day" :loading="loadingDays"
                    :disabled="loadingDays || userData.month === null" item-text="name" label="Día" return-object
                    required filled solo>
                  </v-select>
                </v-col>

                <v-col>
                  <div class="labelsFlex">
                    <label>Mes</label>
                  </div>
                  <v-select class="labelDatesdesktop" style="max-width: 160px; height: 48px;" :rules="monthRules"
                    :items="months" v-model="userData.month" :loading="loadingMonths" v-on:change="getDays()"
                    item-text="name" label="Mes" return-object required filled solo></v-select>
                </v-col>

                <v-col>
                  <div class="labelsFlex">
                    <label>Año</label>
                  </div>
                  <v-select class="labelDatesdesktop" style="max-width: 160px; height: 48px;" :rules="yearRules"
                    value="2022" :items="years" v-model="userData.year" item-text="name" label="Año" return-object
                    required filled solo></v-select>
                </v-col>

              </v-row>

              <br>
              <br>


              <div class="formData">
                <v-row justify="center">
                  <v-dialog v-model="dialog" width="600px">
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">Términos y Condiciones</span>
                      </v-card-title>
                      <v-card-text style="text-align: justify;">
                        Por este acto, y según lo dispuesto en la Ley N° 19.628 sobre Protección de la Vida Privada y
                        sus
                        modificaciones, autorizo expresamente a Southbridge
                        Compañía de Seguros Generales S.A. para que haga tratamiento, almacene, transmita y comunique
                        mis
                        datos
                        personales y la información que le he
                        proporcionado voluntariamente, a su matriz, filiales, sociedades coligadas, empresas
                        relacionadas,
                        sociedades del Grupo Empresarial al que pertenece y
                        terceros prestadores de servicios, estén ubicados dentro o fuera de Chile, con el propósito de
                        que
                        tanto
                        Southbridge Compañía de Seguros Generales
                        S.A. como dichas entidades i) me contacten y pongan a mi disposición, en la forma que estimen
                        pertinente, la más completa información y oferta de sus
                        productos y servicios; ii) procedan al almacenamiento y tratamiento de mis datos personales y de
                        mi
                        información personal para los objetivos del
                        cumplimiento de este Contrato de Seguro; y iii) hagan efectivos el o los convenios que pudieren
                        estar
                        asociados a los seguros que he contratado. Además,
                        por este acto, autorizo expresamente a que cualquier información, comunicación, declaración o
                        notificación que debe efectuar Southbridge Compañía de
                        Seguros Generales S.A. en virtud del presente contrato de seguros sea realizada a través de
                        correo
                        electrónico o de cualquier sistema de transmisión o
                        registro digital de la palabra escrita o verbal o por cualquier otro medio de comunicación
                        fehaciente.
                        El asegurado declara que conoce, acepta y concuerda
                        que cualquier transacción que se realice en el sitio www.sbseguros.cl con su Rut y clave
                        personal, se
                        entenderá y se reputará, para todos los efectos
                        legales, como realizada por él mismo. En tal sentido, el asegurado se hace entera y totalmente
                        responsable del uso y seguridad de su clave, no cabiéndole
                        Southbridge Compañía de Seguros Generales S.A.. ninguna responsabilidad por el uso indebido de
                        la
                        misma
                        por un tercero distinto del asegurado. El
                        asegurable se hace responsable por la veracidad de la información entregada para la contratación
                        del
                        seguro y del uso de las claves o códigos, liberando a
                        Southbridge Compañía de Seguros Generales S.A. de responsabilidad por cualquier mal uso que
                        hagan
                        terceros de la información que Southbridge
                        Compañía de Seguros Generales S.A. entregue exclusivamente a la persona del asegurable.
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          style="box-sizing: border-box; padding: 12px 24px; gap: 10px; background: #FFB600; border: 2px solid #FFB600;
                                  border-radius: 8px; margin-top: -6%; font-family: Helvetica; font-style: normal; font-weight: 700; font-size: 14px; line-height: 17px;
                                  letter-spacing: 0.02em; color: white; flex: none; order: 0; flex-grow: 0; margin:auto;"
                          elevation="0" text @click="dialog = false">
                          Aceptar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-row>

                <div v-if="screen > 800">
                <v-hover style="margin-bottom: -8%;">
                  <v-checkbox :rules="conditionsRules" :color="stepperColor" required>
                    <template v-slot:label>
                      <p
                        style="font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 12px; line-height: 143.34%; letter-spacing: -0.3px; color: #232323; opacity: 0.8; text-align: justify; max-width: 465px; margin-top: 7%;">
                        Al ingresar tus datos y hacer clic en continuar aceptas que tu información sea utilizada para
                        calcular tu estimación de prima de acuerdo a
                        nuestros <b><a style="color:rgba(0, 44, 119, 1)" @click="dialog = true">términos y
                            condiciones</a></b></p>
                    </template>
                  </v-checkbox>
                </v-hover>
                <v-hover>
                  <v-checkbox v-model="acceptMarketing" :color="stepperColor" required>
                    <template v-slot:label>
                      <p
                        style="font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 12px; line-height: 143.34%; letter-spacing: -0.3px; color: #232323; opacity: 0.8; text-align: justify; max-width: 478px; margin-top: 7%;">
                        <b>¡Mantente informado!</b> Autoriza recibir emails con descuentos y beneficios exclusivos sobre tu seguro.
                        </p>
                    </template>
                  </v-checkbox>
                </v-hover>
                </div>

                <div v-else>
                  <v-hover>
                    <v-checkbox :rules="conditionsRules" :color="stepperColor" required>
                      <template v-slot:label>
                        <p
                          style="width: 95%;font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 12px; line-height: 143.34%; letter-spacing: -0.3px; color: #232323; opacity: 0.8; text-align: justify; margin-top: 20%;">
                          Al ingresar tus datos y hacer clic en continuar aceptas que tu información sea utilizada para
                          calcular tu estimación de prima y comunicarnos contigo para éste y otros productos de acuerdo a
                          nuestros <b><a style="color: #3333CC" @click="dialog = true">términos y
                              condiciones</a></b></p>
                      </template>
                    </v-checkbox>
                  </v-hover>
                  <v-hover style="margin-top: -4%;">
                  <v-checkbox v-model="acceptMarketing" :color="stepperColor" required>
                    <template v-slot:label>
                      <p
                        style="width: 94%;font-family: Helvetica; font-style: normal; font-weight: 400; font-size: 12px; line-height: 143.34%; letter-spacing: -0.3px; color: #232323; opacity: 0.8; text-align: justify; max-width: 478px; margin-top: 7%;">
                        <b>¡Mantente informado!</b> Autoriza recibir emails con descuentos y beneficios exclusivos sobre tu seguro.
                        </p>
                    </template>
                  </v-checkbox>
                </v-hover>
                </div>
              </div>


              <div class="button-container">
                <v-btn :class="btnContinue" @click="validate()">Continuar</v-btn>
              </div>
            </v-form>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
  </v-container>
</template>

<script>
import dateService from "@/services/date.service.js";
import yearService from "@/services/year.service.js";
import ShieldService from "../services/shield.service";

import Titulo from "../components/Titulo.vue"
import NavBar from "@/components/NavBar.vue";

import banner from "@/assets/images/Banner.svg";
import bannerMobile from "@/assets/images/BannerMobile.svg";
import casita from "@/assets/images/casita.svg";
import casitaMobile from "@/assets/images/casitaMobile.svg";

import swal from 'sweetalert';
const moment = require('moment');
import CryptoJS from 'crypto-js';

import Vue from "vue";
import { VueReCaptcha } from 'vue-recaptcha-v3'
const { VUE_APP_RECAPTCHA3_SITE_KEY } = process.env;
Vue.use(VueReCaptcha, { siteKey: VUE_APP_RECAPTCHA3_SITE_KEY })

export default {
  name: "Step1",
  components: { Titulo, NavBar },
  data: () => ({
    secretKey: process.env.VUE_APP_CRYPT,
    banner,
    bannerMobile,
    casita,
    casitaMobile,
    version: null,
    stepperStyle: null,
    dividerStyle: null,
    navBarStyle: null,
    btnContinue: null,
    circleStep2Inicio: null,
    formText: '',
    stepperColor: '#EDB321',
    edadMayor: null,
    userData: {
      name: null,
      surname: null,
      serialNumber: null,
      rut: null,
      region: null,
      commune: null,
      regionCode: null,
      comuneCode: null,
      address: null,
      email: null,
      phoneNumber: null,
      couponId: null,
      hasAcode: null,
      stepId: null,
      old: null,
      day: null,
      month: null,
      year: null,
      dates: null,
      typePlan: null,
      PlanName: null,
      datesBenef: null,
      sonExist: false,
    },
    servicesData: {
      stepId: null,
      contactID: null,
      type: 'create',
      acceptMarketing: false,
    },
    dialog: false,
    screen: window.screen.width,
    months: [],
    days: ["Selecciona el mes"],
    yars: [],
    prefijoTelefono: null,
    activeCampaingUse: process.env.VUE_APP_ACTIVE_CAMPAIGN ? process.env.VUE_APP_ACTIVE_CAMPAIGN : 'FALSE',
    valid: false,
    nameRules: [
      (v) => !!v || "El nombre es requerido",
      (v) => !/^[0-9]*$/.test(v) || "Ingrese solo letras",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 caracteres"
    ],
    surnameRules: [
      (v) => !!v || "El apellido es requerido",
      (v) => !/^[0-9]*$/.test(v) || "Ingrese solo letras",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 caracteres"
    ],
    monthRules: [
      (v) => !!v || "El mes es requerido",
    ],
    dayRules: [
      (v) => !!v || "El día es requerido",
    ],
    yearRules: [
      (v) => !!v || "El año es requerido",
    ],
    emailRules: [
      (v) => !!v || "El correo electrónico es requerido",
      (v) => /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v) || "Ingrese un correo válido",
      (v) => (!!v && v.length <= 50) || "Debe ingresar máximo 50 caracteres"
    ],
    conditionsRules: [
      (v) => !!v || "Debe estar de acuerdo con los términos y condiciones",
    ],

  }),
  async mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    document.body.setAttribute('data-sku', 'APS-001-INI');

    this.getMonths();
    this.getYears();

    const query = this.$route.query;
    const userDataAux = sessionStorage.getItem('userData');
    const servicesDataAux = sessionStorage.getItem('servicesData');

    if (query.stepID) {
      const abandoned = await ShieldService.newGetStepAbandoned(query.stepID);

      this.userData = abandoned.userData;
      this.servicesData.stepId = abandoned._id;
      this.servicesData.type = 'update';

      const userDataLocal = JSON.stringify(this.userData);
      const servicesDataLocal = JSON.stringify(this.servicesData);

      const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
      const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();

      sessionStorage.setItem('userData', encryptedUserDataLocal);
      sessionStorage.setItem('servicesData', encryptedServicesDataLocal);

      this.getDaysMounted();

    } else if (userDataAux) {
      const bytesUserData = CryptoJS.AES.decrypt(userDataAux, this.secretKey);
      const decryptedDataUser = bytesUserData.toString(CryptoJS.enc.Utf8);
      this.userData = JSON.parse(decryptedDataUser);
      // console.log("userData: ", this.userData);
      this.getDaysMounted();

      if (servicesDataAux) {
        const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
        const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
        this.servicesData = JSON.parse(decryptedServicesData);
        // console.log("serivcesData: ", this.servicesData);
      }

    } else {
      const userDataLocal = JSON.stringify(this.userData);
      const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
      sessionStorage.setItem('userData', encryptedUserDataLocal);
    }

    if (this.screen > 800) {
      this.formText = 'formData';
      this.stepperStyle = 'stepperStyle';
      this.dividerStyle = 'dividerStyle';
      this.navBarStyle = 'navBarStyle';
      this.btnContinue = 'btnContinue';
      this.circleStep2Inicio = 'circleStep2Inicio';
    } else {
      this.formText = '';
      this.stepperStyle = 'stepperStyle2';
      this.dividerStyle = 'dividerStyle2';
      this.navBarStyle = 'navBarStyle2';
      this.btnContinue = 'btnContinue2';
      this.circleStep2Inicio = 'circleStep2Inicio2';
    }

  },
  methods: {
    async validate() {
      const fechaActual = new moment(new Date());
      if (this.$refs.form.validate()) {
        var newDate = this.userData.year.id + "-" + this.userData.month.number + "-" + this.userData.day.id
        var dateNacimiento = moment(new Date(newDate));
        var timesDiff = fechaActual.diff(dateNacimiento, 'years');
        if (timesDiff < 18) {
          swal({
            title: "Atención!",
            text: "Para contratar este seguro, usted debe ser mayor de edad!",
            icon: "info",
            button: "De acuerdo",
          });
        } else if (timesDiff > 69) {
          swal({
            title: "Atención!",
            text: "Para contratar este seguro, usted debe ser menor a 69 años!",
            icon: "info",
            button: "De acuerdo",
          });
        } else {

          this.userData.dates = newDate;
          this.userData.old = timesDiff;

          this.change();

          const userDataLocal = JSON.stringify(this.userData);
          const encryptedUserDataLocal = CryptoJS.AES.encrypt(userDataLocal, this.secretKey).toString();
          sessionStorage.setItem('userData', encryptedUserDataLocal);

          var shieldRes;
          if (this.activeCampaingUse == 'TRUE') {
            const activeCampaingRes = await ShieldService.getContactActiveCampain(this.userData.email);

            if (activeCampaingRes.data.data.meta.total == 1) {
              this.servicesData.contactID = activeCampaingRes.data.data.contacts[0].id;
              await ShieldService.updateContactActiveCampain(this.userData, null, this.servicesData, 0);
            } else {
              shieldRes = await ShieldService.createContactActiveCampain(this.userData, this.servicesData);

              if (shieldRes.data.status == 'ok') {
                this.servicesData.contactID = shieldRes.data.data.contacts[0].id;
              }
            }

            const servicesDataLocal = JSON.stringify(this.servicesData);
            const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
            sessionStorage.setItem('servicesData', encryptedServicesDataLocal);

          }

          this.$router.push({ path: '/ap/planes' })
        }

      }
    },
    async getMonths() {
      this.loadingMonths = true;
      this.months = await dateService.getMonths();
      this.loadingMonths = false;
    },
    async getDays() {
      if (this.userData.month) {
        this.loadingDays = true;
        this.userData.day = null;
        this.days = await dateService.getDays(
          this.userData.month.name
        );
        this.loadingDays = false;
      }
    },
    async getDaysMounted() {
      if (this.userData.month) {
        this.loadingDays = true;
        this.days = await dateService.getDays(
          this.userData.month.name
        );
        this.loadingDays = false;
      }
    },
    async getYears() {
      this.loadingYears = true;
      this.years = await yearService.getYears();
      this.loadingYears = false;
    },
    async change() {

      // reCaptcha v3 token
      await this.$recaptchaLoaded();
      const tokenStep = await this.$recaptcha('captchaToken');

      try {

        const servicesDataAux = sessionStorage.getItem('servicesData');

        if (servicesDataAux) {
          const bytesServicesData = CryptoJS.AES.decrypt(servicesDataAux, this.secretKey);
          const decryptedServicesData = bytesServicesData.toString(CryptoJS.enc.Utf8);
          this.servicesData = JSON.parse(decryptedServicesData);
          // console.log("serivcesData: ", this.servicesData);
        }

        var carro = await ShieldService.newCreateStep(this.userData, null, null, this.servicesData, 'Inicio', tokenStep);
        this.servicesData.type = 'update';
        this.servicesData.stepId = carro.data.data._id;

        const servicesDataLocal = JSON.stringify(this.servicesData);
        const encryptedServicesDataLocal = CryptoJS.AES.encrypt(servicesDataLocal, this.secretKey).toString();
        sessionStorage.setItem('servicesData', encryptedServicesDataLocal);

      } catch (error) {
        console.log("Cart Fail");
      }
    }
  },
};
</script>
<style lang="scss" scoped>

.labelText{
  color: #4D4D4D;
  font-weight: 700;
}
.circle-step2-inicio-thirst{
  margin-top: -1.2%;
}
.circle-step2-inicio-final{
  margin-top: -0.5%;
}
@media (max-width: 950px) {
  .stepperStyle2 {
    font-size: 10px !important;
    line-height: 1.2;
    text-align: center;
    display: flex;             
    align-items: center;        
    justify-content: center;   
    height: 24px; 
    margin-top: 4px;
  }
  .dividerStyle2 {
    flex: 0 0 auto !important; 
    align-self: center; 
    margin: 0 4px !important; 
  }
  .v-stepper__step {
    align-items: center !important;
  }
  .circle-step2-thirst{
    margin-top: 0%;
  }
  .circle-step2-inicio-final{
    margin-top: 0%;
  }
}
</style>


<style lang="scss">
.circleStep2Inicio{
  margin-top: -1.7%;
}
.btnContinue {
    background-color: #2D387C !important; 
    color: white !important;
    border-radius: 24px; 
    width: 300px; 
    height: 120%; 
    margin-left: 5%; 
    font-family: Helvetica !important;
    font-style: normal !important;
    font-weight: 600 !important;
    text-transform: none;
    letter-spacing: 0.1px; 
}
.btnContinue2 {
    background-color: #2D387C !important; 
    color: white !important;
    border-radius: 24px; 
    width: 200px; 
    height: 120%; 
    margin-left: 5%; 
    font-family: Helvetica !important;
    font-style: normal !important;
    font-weight: 600 !important;
    text-transform: none;
    letter-spacing: 0.1px; 
}
.v-input.v-input--checkbox.v-input--is-dirty .v-icon {
  color: #4F74E3 !important;  
}

.v-input.v-input--checkbox:not(.v-input--is-dirty) .v-icon {
  color: #999 !important;   
}
.v-input.v-input--checkbox .v-input--selection-controls__ripple {
  background-color: transparent !important;
  opacity: 0 !important;
}

.navBarStyle2{
  margin-top: 3%;
  margin-bottom: 6%;
}
.labels{
  color: #525252;
  font-weight: 600;
  margin-bottom: 1% !important;
}
.labelsSelectMobile{
  color: #525252;
  font-weight: 600;
  margin-bottom: 1% !important;
  margin-left: 5% !important;
}
.labelsFlex{
  color: #525252;
  margin-bottom: -3% !important;
}
.labelHola {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 26px;
  letter-spacing: -0.01em; //ojo -0.22px;
  color: #2D387C;
  mix-blend-mode: darken; //ojo
}

.labelNombre {
  box-sizing: border-box;
  height: 57px;
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  margin: auto;
  border-radius: 6px;
}

.labelQuestion {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 15px;
  letter-spacing: -0.01em; // -0.18px;
  color: #2D387C;
}

.labelSubQuestion {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 13px; //16px
  line-height: 16px;
  color: #333;
  opacity: 0.75;
  padding: 2%;
}

.labelEmail {
  box-sizing: border-box;
  height: 57px;
  margin: auto;
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
}

.labelEdad {
  max-width: 163px;
  height: 57px;
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
}


.step-date {
  max-width: 200px;
  align-items: center;
  display: flex;
  margin-left: 2rem;
  justify-content: center;

  .v-select {
    max-width: 150px;
  }
}

.labelDatesMovil {
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
}

.labelDatesdesktop {
  background: #FFFFFF;
  border: 1.5px solid rgba(142, 142, 142, 0.2);
  box-shadow: 0px 1.5px 15px -2.5px rgba(32, 32, 32, 0.08);
  border-radius: 6px;
  min-height: 57px;
}

.v-input .v-label {
  font-size: 12px;
  color: #8E8E8E;
}

.formData {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.v-messages__message {
  padding-bottom: 10%;
  text-align: center;
}

.v-btn__content {
  padding: 0.75rem;
}

.mdi-chevron-left {
  color: #002C77 !important;
}

.button-container {
  text-align: center;
}

html body div#app.v-application.v-application--is-ltr.theme--light div.v-application--wrap main.v-main div.v-main__wrap div.container div.v-stepper.v-sheet.theme--light.elevation-0 div.v-stepper__items div.v-stepper__content div.v-stepper__wrapper div.formData form.v-form div.formData div.v-input.v-input--has-state.theme--light.v-input--selection-controls.v-input--checkbox.error--text div.v-input__control div.v-messages.theme--light.error--text div.v-messages__wrapper div.v-messages__message {
  text-align: center;
}

// _________________________________________________
// _________________________________________________

.first-col{
  // margin-left: 14%; 
  margin-top: -6%;
}

.second-row{
  text-align: center; 
  justify-content: start; 
  align-items: center; 
  
}

.banner-img{
  width: 100%;
  height: 220px;
  // margin-left: 40%;
  margin-bottom: 3%;
  // margin-right: 14%;
  margin-left: 44%; 
  margin-top: -15%;
}

@media (min-width: 1920px){
  .banner-img{
  width: 100%;
  margin-left: 35%;
  margin-top: -10%;
}
}

// @media only screen and (min-width: 390px) and (max-width: 430px){
//   .banner-img{
//   width: 100%;
//   // margin-left: 40%;
//   }
// }



.casita-img{
  margin-right: 10px;
}

@media (min-width: 1920px){
  .casita-img{
    margin-left: 18%;
}
}

.seguroHogar-text{
  font-size: 20px;
  color: rgba(0, 44, 119, 1);
}

.text-banner{
  font-size: 13px;
  color: #555555;
}

@media (min-width: 951px) and (max-width: 1200px){
  .text-banner{
    font-size: 10px;
    color: #555555;
  }
}

@media (max-width: 950px){
  .text-banner{
    font-size: 12px;
    color: 555555;
  }
  .labelSubQuestion {
  font-family: Helvetica;
  font-style: normal;
  font-weight: 400;
  font-size: 13px; //16px
  line-height: 16px;
  color: #333;
  opacity: 0.75;
  padding: 2%;
  margin-top: 4%;
  margin-bottom: 4%;
}
}

// _________________________________________________
// _________________________________________________

.margin-top{
  margin: auto; 
  margin-top: -5%;
}

@media (min-width: 1920px){
  .margin-top{
    margin: auto; 
    margin-top: -3%;
  }
}

</style>